import { useEffect, useState } from "react";
import { WifiSlash, ArrowsClockwise } from "@phosphor-icons/react";

export default function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  const [updateReady, setUpdateReady] = useState(false);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    const onUpdate = () => setUpdateReady(true);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    window.addEventListener("pwa:update-available", onUpdate);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("pwa:update-available", onUpdate);
    };
  }, []);

  if (online && !updateReady) return null;

  if (updateReady && online) {
    return (
      <div
        data-testid="pwa-update-banner"
        className="fixed top-14 md:top-3 inset-x-3 md:inset-x-auto md:right-6 md:max-w-sm z-[55] bg-[#FF9800] text-white shadow-lg"
      >
        <div className="flex items-center gap-3 p-3">
          <ArrowsClockwise size={16} weight="bold" />
          <div className="flex-1 text-xs font-bold uppercase tracking-widest">
            New version available
          </div>
          <button
            onClick={() => window.location.reload()}
            className="text-[10px] font-bold uppercase tracking-widest underline"
          >
            Refresh
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="offline-banner"
      className="fixed top-14 md:top-0 inset-x-0 z-[55] bg-amber-400 text-amber-950 border-b border-amber-500"
    >
      <div className="flex items-center justify-center gap-2 px-4 py-2 text-[11px] font-bold uppercase tracking-widest">
        <WifiSlash size={14} weight="bold" />
        Offline · cached data shown · stock writes paused
      </div>
    </div>
  );
}
